import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/** Технологичный фон с объемными связями (логин / публичные страницы). */
export const TechBackground = ({ isLightTheme = false }) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: isLightTheme ? 0.25 : 0.12,
      overflow: 'hidden',
      zIndex: 0,
    }}
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1200 800"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <radialGradient id="nodeGrad" cx="50%" cy="30%" r="70%">
          <stop offset="0%" stopColor={isLightTheme ? '#2E7D32' : '#4CAF50'} stopOpacity={isLightTheme ? '0.7' : '0.8'} />
          <stop offset="100%" stopColor={isLightTheme ? '#1565C0' : '#2196F3'} stopOpacity={isLightTheme ? '0.5' : '0.4'} />
        </radialGradient>
        <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isLightTheme ? '#1565C0' : '#2196F3'} stopOpacity="0.6" />
          <stop offset="50%" stopColor={isLightTheme ? '#0097A7' : '#00BCD4'} stopOpacity={isLightTheme ? '0.7' : '0.8'} />
          <stop offset="100%" stopColor={isLightTheme ? '#2E7D32' : '#4CAF50'} stopOpacity={isLightTheme ? '0.5' : '0.4'} />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <g opacity="0.3">
        <line x1="0" y1="100" x2="1200" y2="120" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="200" x2="1200" y2="180" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="300" x2="1200" y2="320" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="400" x2="1200" y2="380" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="500" x2="1200" y2="520" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="600" x2="1200" y2="580" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="0" y1="700" x2="1200" y2="720" stroke="url(#lineGrad)" strokeWidth="1" />

        <line x1="150" y1="0" x2="130" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="300" y1="0" x2="320" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="450" y1="0" x2="430" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="600" y1="0" x2="620" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="750" y1="0" x2="730" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="900" y1="0" x2="920" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="1050" y1="0" x2="1030" y2="800" stroke="url(#lineGrad)" strokeWidth="1" />
      </g>

      <g filter="url(#glow)">
        <circle cx="200" cy="150" r="12" fill="url(#nodeGrad)" />
        <circle cx="500" cy="250" r="15" fill="url(#nodeGrad)" />
        <circle cx="800" cy="200" r="18" fill="url(#nodeGrad)" />
        <circle cx="1000" cy="350" r="14" fill="url(#nodeGrad)" />

        <circle cx="150" cy="450" r="16" fill="url(#nodeGrad)" />
        <circle cx="650" cy="500" r="13" fill="url(#nodeGrad)" />
        <circle cx="900" cy="600" r="17" fill="url(#nodeGrad)" />
        <circle cx="300" cy="650" r="11" fill="url(#nodeGrad)" />

        <circle cx="350" cy="180" r="8" fill={isLightTheme ? '#0097A7' : '#00BCD4'} opacity={isLightTheme ? '0.9' : '0.7'} />
        <circle cx="720" cy="320" r="9" fill={isLightTheme ? '#2E7D32' : '#4CAF50'} opacity={isLightTheme ? '0.8' : '0.6'} />
        <circle cx="420" cy="380" r="7" fill={isLightTheme ? '#1565C0' : '#2196F3'} opacity={isLightTheme ? '1.0' : '0.8'} />
        <circle cx="850" cy="450" r="6" fill={isLightTheme ? '#0097A7' : '#00BCD4'} opacity={isLightTheme ? '0.8' : '0.6'} />
        <circle cx="250" cy="300" r="5" fill={isLightTheme ? '#2E7D32' : '#4CAF50'} opacity={isLightTheme ? '0.9' : '0.7'} />
        <circle cx="700" cy="150" r="4" fill={isLightTheme ? '#1565C0' : '#2196F3'} opacity={isLightTheme ? '0.7' : '0.5'} />

        <circle cx="180" cy="280" r="3" fill={isLightTheme ? '#0097A7' : '#00BCD4'} opacity={isLightTheme ? '0.6' : '0.4'} />
        <circle cx="480" cy="120" r="2" fill={isLightTheme ? '#2E7D32' : '#4CAF50'} opacity={isLightTheme ? '0.7' : '0.5'} />
        <circle cx="750" cy="380" r="3" fill={isLightTheme ? '#1565C0' : '#2196F3'} opacity={isLightTheme ? '0.8' : '0.6'} />
        <circle cx="950" cy="200" r="2" fill={isLightTheme ? '#0097A7' : '#00BCD4'} opacity={isLightTheme ? '0.5' : '0.3'} />
        <circle cx="120" cy="520" r="2" fill={isLightTheme ? '#2E7D32' : '#4CAF50'} opacity={isLightTheme ? '0.6' : '0.4'} />
        <circle cx="580" cy="580" r="3" fill={isLightTheme ? '#1565C0' : '#2196F3'} opacity={isLightTheme ? '0.7' : '0.5'} />
        <circle cx="820" cy="650" r="2" fill={isLightTheme ? '#0097A7' : '#00BCD4'} opacity={isLightTheme ? '0.5' : '0.3'} />
        <circle cx="380" cy="720" r="2" fill={isLightTheme ? '#2E7D32' : '#4CAF50'} opacity={isLightTheme ? '0.6' : '0.4'} />
      </g>

      <g opacity="0.4">
        <line x1="200" y1="150" x2="500" y2="250" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="500" y1="250" x2="800" y2="200" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="800" y1="200" x2="1000" y2="350" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="150" y1="450" x2="650" y2="500" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="650" y1="500" x2="900" y2="600" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="300" y1="650" x2="150" y2="450" stroke="url(#lineGrad)" strokeWidth="1.5" />
        <line x1="350" y1="180" x2="720" y2="320" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="420" y1="380" x2="850" y2="450" stroke="url(#lineGrad)" strokeWidth="1" />
        <line x1="250" y1="300" x2="700" y2="150" stroke="url(#lineGrad)" strokeWidth="1" />
      </g>
    </svg>
  </Box>
);

TechBackground.propTypes = {
  isLightTheme: PropTypes.bool,
};
